module.exports = __webpack_public_path__ + "338a622f32d29cf3e1d357eae21e7e27.png";